/**
 * Bottle sizes are the unit of inventory for fragrances: every product keeps a
 * separate stock count per bottle size. Client-safe module (no backend access)
 * so storefront, admin and server code share one definition.
 */
export type BottleSize = 10 | 20 | 50 | 100;

export const BOTTLE_SIZES: BottleSize[] = [10, 20, 50, 100];

/** Default low-stock threshold, evaluated independently per size. */
export const LOW_STOCK_THRESHOLD = 10;

export function sizeLabel(ml: number): string {
  return `${ml} ML`;
}

/** Maps a cart/PDP variant id ("100", "100ml", "100 ML") onto a bottle size. */
export function parseSizeMl(variantId: string | null | undefined, fallback: BottleSize = 100): BottleSize {
  const digits = String(variantId ?? "").replace(/[^0-9]/g, "");
  const n = Number(digits);
  return (BOTTLE_SIZES as number[]).includes(n) ? (n as BottleSize) : fallback;
}

export type SizeStockRow = {
  productId: string;
  sizeMl: number;
  onHand: number;
  lowThreshold: number;
};

export type InventoryRow = {
  productId: string;
  name: string;
  slug: string;
  sizes: Record<string, number>;
  thresholds: Record<string, number>;
};

export function stockTone(qty: number, threshold = LOW_STOCK_THRESHOLD): "out" | "low" | "ok" {
  if (qty <= 0) return "out";
  if (qty <= threshold) return "low";
  return "ok";
}
